import { useVendorAuth } from "auth/VendorAuth/hooks";
import { setToken } from "auth/VendorAuth/vendorUserSlice";
import axios from "axios";
import { useAppDispatch } from "hooks/redux";
import { useNavigate } from "react-router-dom";
import "../App.css";
import Loading from "../components/Loading";
import "../styles/react-grid-layout.css";
import "../styles/react-resizable.css";

const LoginCallback = () => {
  // Hooks
  const { loginInProgress, isAuthContextConfigured,  idToken } =
    useVendorAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Render
  if (loginInProgress || !isAuthContextConfigured || !idToken) {
    return <Loading />;
  }

  localStorage.removeItem("currentUser");
  localStorage.removeItem("authorized");
  localStorage.removeItem("SystemTokenExpire");

  const preLoginPath = localStorage.getItem("preLoginPath");
  // console.log("token", token);
  // console.log("idToken", idToken);
  // console.log("error", error);

  axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
  // console.log("GettingProfile");
  axios
    .post(`/api/v1/VendorUsers/registeruser`)
    .then((response: any) => {
      axios.defaults.headers.common["Authorization"] = "";
      axios.defaults.withCredentials = true;
      // console.log("Profile response", response);
      sessionStorage.removeItem("ROCP_tokenExpire");
      sessionStorage.removeItem("ROCP_refreshTokenExpire");
      //ROCP_token
      //ROCP_idToken
      //localStorage.removeItem("ROCP_token");
      //localStorage.removeItem("ROCP_idToken");
      navigate(preLoginPath as string);
    })
    .catch(() => {
      dispatch(setToken(undefined));
      sessionStorage.removeItem("ROCP_tokenExpire");
      sessionStorage.removeItem("ROCP_refreshTokenExpire");
      sessionStorage.removeItem("ROCP_token");
      sessionStorage.removeItem("ROCP_idToken");
    });

  return <Loading />;
};

export default LoginCallback;
